import { Tabs, Tab, Badge, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useToolBuilder } from '../../Hook'
import { useAppSelector } from 'redux/Hook'
import { a11yProps } from 'lib/Helper'

function ToolTabs({ toolTabValue, setToolTabValue }: any) {
  const { t } = useTranslation()
  const { fetching, saving, invalidGroups } = useAppSelector(
    (state) => state.toolBuilder,
  )

  const { toolTabs } = useToolBuilder()

  return (
    <Tabs
      variant="scrollable"
      value={toolTabValue}
      aria-label={t('toolBuilder.toolOptions')}
      onChange={(_, newValue) => setToolTabValue(newValue)}
    >
      {toolTabs.map((tool, index) => (
        <Tab
          key={tool}
          disabled={fetching || saving}
          label={
            invalidGroups?.includes(tool) ? (
              <Box p={1}>
                <Badge
                  color="error"
                  variant="dot"
                  sx={{ '& .MuiBadge-badge': { right: -15, top: 4 } }}
                >
                  {tool.toUpperCase()}
                </Badge>
              </Box>
            ) : (
              tool.toUpperCase()
            )
          }
          sx={{ minHeight: 64 }}
          {...a11yProps(tool + '-tab', index)}
        />
      ))}
    </Tabs>
  )
}

export default ToolTabs
